import React, { Component } from 'react';
import { object, bool, string, func, number, array, oneOf, any } from 'prop-types';
import updateRoute from '../Utils/updateRoute';
import { withRouter } from 'react-router';

import './FullPageSlideOut.scss';

export class FullPageSlideOut extends Component {
  static propTypes = {
    isOpen: bool.isRequired,
    children: any.isRequired,
    className: string,
    from: oneOf(['left', 'right']),
    width: string,
    fixedPosition: bool,
    zIndex: number,
    minWidth: string,
    maxWidth: string,
    handleCloseSlideOut: func,
    height: string,
    top: string,
    paddingTop: string,
    delayToTriggerAnimationInSeconds: number,
    endpoint: string,
    history: object,
    location: object
  };

  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      readyToOpen: !this.props.delayToTriggerAnimationInSeconds
    };

    this.closeSlideout = this.closeSlideout.bind(this);
  }

  closeSlideout() {
    // Don't double-call the handle close, only call handle close when the slideout is open
    if (this.props.handleCloseSlideOut && this.props.isOpen) {
      this.props.handleCloseSlideOut();
    }
  }

  componentDidMount() {
    this.setState({
      mounted: true,
      readyToOpen: !this.props.delayToTriggerAnimationInSeconds
    });
    if (this.props.delayToTriggerAnimationInSeconds && this.props.isOpen) {
      this.triggerAnimation();
    }
    if (this.props.isOpen && this.props.endpoint) {
      updateRoute(this.props.location.pathname, this.props.endpoint, this.props.history, this.props.isOpen);
    }

    // If we have a route, listen for the back button to close the slideout
    if (this.props.endpoint && this.props.handleCloseSlideOut) {
      window.addEventListener('popstate', this.closeSlideout);
    }
  }

  componentWillUnmount() {
    if (this.props.endpoint && this.props.handleCloseSlideOut) {
      window.removeEventListener('popstate', this.closeSlideout);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.delayToTriggerAnimationInSeconds && this.props.isOpen !== prevProps.isOpen) {
      this.triggerAnimation();
    }
    if (this.props.endpoint && this.props.isOpen !== prevProps.isOpen) {
      updateRoute(this.props.location.pathname, this.props.endpoint, this.props.history, this.props.isOpen);
    }
  }

  triggerAnimation() {
    setTimeout(() => {
      this.setState({
        readyToOpen: !this.state.readyToOpen
      });
    }, this.props.delayToTriggerAnimationInSeconds * 1000);
  }

  render() {
    /** PXL uses z:150 for their drop downs **/
    const {
      isOpen,
      children,
      className,
      from = 'right',
      width = 200,
      fixedPosition,
      zIndex = 151,
      minWidth,
      maxWidth,
      height,
      top,
      paddingTop
    } = this.props;

    // Outer Container Styles
    const containerStyles = {
      left: from === 'right' ? '100%' : '0'
    };
    if (zIndex) containerStyles.zIndex = zIndex;
    if (fixedPosition) containerStyles.position = 'fixed';
    if (isOpen && this.state.mounted && this.state.readyToOpen) {
      containerStyles.display = 'block';
      containerStyles.transform = from === 'right' ? 'translate(-100%)' : 'translate(100%)';
    }

    // Panel Itself
    const panelStyles = {
      width: width,
      height: height ? height : '100%'
    };
    if (from === 'right') {
      panelStyles.right = '0';
    }
    if (minWidth) {
      panelStyles.minWidth = minWidth;
    }
    if (maxWidth) {
      panelStyles.maxWidth = maxWidth;
    }
    if (top) {
      panelStyles.top = top;
    }
    if (paddingTop) {
      panelStyles.paddingTop = paddingTop;
    }
    if (zIndex) {
      panelStyles.zIndex = zIndex + 1;
    }

    return (
      <div
        className={`page__slideout ${isOpen && this.state.mounted && this.state.readyToOpen ? ' toggled' : ''}`}
        style={containerStyles}
      >
        <div className="page__slideout--overlay" onClick={this.closeSlideout} />
        <div className={`page__slideout--panel ${className ? className : ''}`} style={panelStyles}>
          {children}
        </div>
      </div>
    );
  }
}

export default withRouter(FullPageSlideOut);
